import { PageLayout } from 'src/shared/layout/PageLayout'
import { SecondLevelNavigation, SecondLevelNavigationContainer } from 'src/routing/SecondLevelNavigation'
import { ROUTES } from 'src/routing/routes'
import { NestedRoute, Route, SecondLevelRoute } from 'src/routing/routing'
import { Outlet, useLocation } from 'react-router'
import { useEffect, useState } from 'react'
import { Location } from 'history'

const resolveActiveRoute = (location: Location): SecondLevelRoute => {
  const nested = ROUTES.PrinciplesConfigurationIndex!.nested! as unknown as NestedRoute
  const activeRoute = Object.keys(nested).find(
    (key) =>
      location.pathname.endsWith(`/${nested[key].path}`) ||
      (ROUTES.PrinciplesConfigurationIndex.params({}) === location.pathname && nested[key].primary),
  ) as string
  return nested[activeRoute] as SecondLevelRoute
}

export const PrinciplesConfigurationIndexPage = () => {
  const location = useLocation()
  const [activeRoute, setActiveRoute] = useState<SecondLevelRoute>(() => {
    return resolveActiveRoute(location)
  })

  useEffect(() => {
    const newActiveRoute = resolveActiveRoute(location)
    setActiveRoute(newActiveRoute)
  }, [location])

  const showNavigation = activeRoute && !activeRoute.hideNavigation

  return (
    <SecondLevelNavigationContainer $showNavigation={showNavigation}>
      {showNavigation && (
        <PageLayout>
          <SecondLevelNavigation
            activeRoute={activeRoute}
            route={ROUTES.PrinciplesConfigurationIndex as unknown as Route}
            baseUrl={ROUTES.PrinciplesConfigurationIndex.params({})}
          />
        </PageLayout>
      )}
      <Outlet />
    </SecondLevelNavigationContainer>
  )
}
